import { GiftGraphic, GIFT_COLORS } from "./Windows/GiftUI/GiftGraphic";


/**
 * config = {
 *  x: number,
 *  y: number
 * }
 */

G.MapGift = function(config) {

  Phaser.Group.call(this,game);

  this._config = config || {};
  this.ignorePosition = !this._config.x && !this._config.y;
  if (!this.ignorePosition) {
    this.position.setTo(0,240);
  }

  this.isMGUnlocked = OMT.feature.getFeature3hGiftActiveByLevel();

  //if (!G.saveState.data.lastMapGiftOpenTime) G.saveState.data.lastMapGiftOpenTime = 0;

  this.msGiftCooldown = G.json.settings.mapGiftTimeMinutes * 60 * 1000;

  // this.active = Date.now() - G.saveState.data.lastMapGiftOpenTime > this.msGiftCooldown;
  this.active = G.saveState.getUserCooldownRemaining('3h_gift', '') === 0;

  this.mapGiftContainer = new Phaser.Group(game);
  // this.addGlow();

  const btnConfig = { 
    giftType: 1,
    useFullGift: true,
    isButton: true,
    callback: this.open,
    callbackContext: this,
  };
  this.btn = new GiftGraphic(0, 0, btnConfig, this);
  // this.btn = new G.Button(0, 0,'gift_3',this.open,this);

  btnConfig.isButton = false;
  this.btnDarkOverlay = new GiftGraphic(0, 0, btnConfig, this.btn);
  // this.btnDarkOverlay = G.makeImage(0, 0, 'gift_3', 0.5, this.btn);
  this.btnDarkOverlay.setTintForAll(0x000000);
  this.btnDarkOverlay.alpha = 0.5;

  this.btn.scale.setTo(0.5);
  this.mapGiftContainer.add(this.btn);
  this.btn.btnSprite.addTerm(function(){
    return this.active;
  },this);

  this.add(this.mapGiftContainer);

  if (this.isMGUnlocked) {
    this._addTimer();
    if (!this.active) {
      this.startTimer();
    }
    this.notificationBubble = new G.NotificationBubble(30, -25);
    this.mapGiftContainer.add(this.notificationBubble);
  }
  else {
    this.unlockTxt = new G.Text(0, 0, OMT.language.getText('Unlock at Level X').replace('X',G.featureUnlock.unlockLevels.isShowing3hGift+1), "font-white",0.5,150,150, true, 'center');
    this.unlockTxt.lineSpacing = -15;
    this.unlockTxt.setShadow(0, 0, 'black', 3);

    game.add.tween(this.unlockTxt.scale).to({x:0.9,y:0.9},500,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);

    this.add(this.unlockTxt);
  }



  if (!this.ignorePosition) {
    G.sb("onScreenResize").add(this.onResize,this);
    this.onResize();
  }
};

G.MapGift.prototype = Object.create(Phaser.Group.prototype);

G.MapGift.prototype.update = function() {

  // if (Date.now() - G.saveState.data.lastMapGiftOpenTime > this.msGiftCooldown) {
  if (G.saveState.getUserCooldownRemaining('3h_gift', '') === 0) {
    this.active = true;
    this.ignoreChildInput = false;
  } else {
    if (this.active) {
      this.startTimer();
    }
    this.active = false;
    this.ignoreChildInput = true;
  }

  if (this.isMGUnlocked) {
    this.notificationBubble.setImportant(this.active);
    this.timer.visible = !this.active;
  }
  this.btnDarkOverlay.visible = !this.active;
};

G.MapGift.prototype.onResize = function(){
	var center = game.world.bounds.x+Math.floor(game.width*0.5);
  this.x = center + G.OMTsettings.elements.mapGift.xCenterOffset;
  this.y = G.OMTsettings.elements.mapGift.y;
};

G.MapGift.prototype.open = function(){
  if (!this.isMGUnlocked) { return; }
  if (OMT.feature.is3hGiftInShop()) {
    G.sb('pushWindow').dispatch(['coinShop', { hideFreeGift: false }]);
  } else {
    var gifts;
    var onClaim;
    var giftConfig = G.Utils.clone(G.json.settings.GingyGiftSettings);

    onClaim = function(){
      G.sb("mapGiftCollect").dispatch();
      // G.saveState.data.lastMapGiftOpenTime = Date.now();
      G.saveState.setUserCooldown('3h_gift', '', 1000 * 60 * 60 * 3);
    };

    giftConfig.onClaim = onClaim;
    giftConfig.gifts = getGifts();
    giftConfig.placement = G.BuildEnvironment.adPlacements.double3hGift;
    if(!game.incentivised() || !G.featureUnlock.mapGiftDoubling){
      giftConfig.monetiseType = false;
    }

    G.sb("pushWindow").dispatch(['gift', giftConfig], false, G.WindowMgr.LayerNames.BelowHeaderPanel);
  }

  function getGifts() {
    if (G.IAP) {
      return [G.gift.getGift('3H_Gift')];
    } else {
      if(Math.random() < giftConfig.chanceToGetBooster){
        return [
          G.gift.getGift('normalsGingyGift_boosters',true)
        ];
      } else {
        return [
          G.gift.getGift('normalsGingyGift_coins',true)
        ];
      }
    }
  }
};

G.MapGift.prototype._addTimer = function() {
  this.timer = new G.TextTimer(0, G.OMTsettings.elements.mapGift.timer.y, null, {
    style: "font-white",
    fontSize: "30px"
  }, 0.5, 130);
  this.add(this.timer);
};

G.MapGift.prototype.startTimer = function() {
  const curTime = Date.now();
  /*
  if (G.saveState.data.lastMapGiftOpenTime > curTime) { // In case of time travellers
    G.saveState.data.lastMapGiftOpenTime = curTime;
  }
  */
  // var secLeft = Math.min(Math.floor(((G.saveState.data.lastMapGiftOpenTime+this.msGiftCooldown)-curTime)/1000), (this.msGiftCooldown / 1000));  // In case its not because of time
  var secLeft = G.saveState.getUserCooldownRemaining('3h_gift', '') / 1000;
  this.timer.setSecLeft(secLeft);
  this.timer.active = true;
};

G.MapGift.prototype.addGlow = function() {
  this.glow = G.makeImage(0,0,'popup_lighht',0.5,this);
  this.glow.alpha = 0.5;
  this.glow.scale.setTo(0.5);
  this.glow.blendMode = 1;
};
